import { render, staticRenderFns } from "./SalesTab.vue?vue&type=template&id=b3890a0e&"
import script from "./SalesTab.vue?vue&type=script&lang=js&"
export * from "./SalesTab.vue?vue&type=script&lang=js&"
import style0 from "./SalesTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QBtn,QMenu,QList,QItem,QItemSection,QSeparator,QSlider,QBtnToggle,QBtnGroup,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QBtn,QMenu,QList,QItem,QItemSection,QSeparator,QSlider,QBtnToggle,QBtnGroup})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
